import { Tooltip } from 'antd';
import { primaryFont, secondaryHeadingColor, wMedium } from 'constants/utilsStyles';
import React from 'react';
import styled from 'styled-components';


type Props = {
  color: string,
  title: string,
  showTooltip?: boolean,
};

const defaultProps = {
  showTooltip: false,
};

const Wrapper = styled.div<{title?: String}>`
  display: flex;
  align-items: center;
  .title {
    font-size: 14px;
    line-height: 18px;
    color: ${secondaryHeadingColor};
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    margin-bottom: 0px;
    width: calc(100% - 15px);
  }
`;

const Bullet = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  height: 10px;
  border-radius: 50%;
`;

const PersonalityBulletWidget = function PersonalityBulletWidget(props: Props) {
  const { title, color, showTooltip } = props;
  return (
    <Wrapper className='personality-bullet-widget'>
      <Bullet className="bullet" style={{minWidth: title === 'N/A' ? '0px' : '10px'}} color={color} />
      {showTooltip ? (
        <Tooltip
          placement="top"
          getPopupContainer={(e: HTMLElement) => e}
          className="triggers-bullet-tooltip"
          title={title}
        >
          <h6 style={{marginLeft: title === 'N/A' ? '0px' : '8px', width: title === 'N/A' ? 'auto' : 'calc(100% - 15px)'}} className="title text-truncate personality-bulltet-title">{title}</h6>
        </Tooltip>
      ) : (
        <h6 style={{marginLeft: title === 'N/A' ? '0px' : '8px', width: title === 'N/A' ? 'auto' : 'calc(100% - 15px)'}} className="title text-truncate personality-bulltet-title">{title}</h6>
      )}
    </Wrapper>
  );
};
PersonalityBulletWidget.defaultProps = defaultProps;
export default PersonalityBulletWidget;
